interface IDatePicker {
    setInputValueDate?: any;
    inputValueDate?: string;
    setState?: any;
    stateDate?: any;
    name: string;
    isEdit?: boolean;
    isCreateActionPage?: boolean;
    isPlanEdit?: boolean;
    isCreateMoment?: boolean;
    isTouched?: boolean;
    type?: 'start' | 'end';
    placeholderText?: string;
    validateMessage?: string;
    handleFilterDateChange?: any;
}

interface IAppStateReducer {
    selectedDate?: Date;
    dateOfMarriage?: Date;
    formattedDate?: string;
    inputValue?: string;
    showMonthYearPicker: boolean;
    showYearPicker: boolean;
    showDayPicker: boolean;
    openDatePicker: boolean;
}

const appStateReducer = (prev: IAppStateReducer, next: Partial<IAppStateReducer>): IAppStateReducer => {
    return { ...prev, ...next };
};
export { appStateReducer };
export type { IDatePicker, IAppStateReducer };
